var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "atm / images / icon/alert/M/succes") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M16,-5.33184608e-14 C24.8225402,-5.33184608e-14 32,7.17745984 32,16 C32,19.3449015 30.9784216,22.5498776 29.0464082,25.2639723 C28.7440598,25.6899222 28.1495699,25.7893963 27.7212636,25.4867256 C27.2934004,25.1824674 27.1930654,24.5910186 27.497082,24.161596 C29.1994125,21.7701897 30.0990099,18.9478287 30.0990099,16 C30.0990099,8.22586192 23.7736529,1.9009901 16,1.9009901 C8.22634707,1.9009901 1.9009901,8.22586192 1.9009901,16 C1.9009901,23.7741381 8.22634707,30.0990099 16,30.0990099 C18.331817,30.0990099 20.6411242,29.518161 22.6787487,28.4194132 C23.1402345,28.1734146 23.7169033,28.3450632 23.9651863,28.8056187 C24.2140973,29.2673392 24.0415032,29.84324 23.5793324,30.0942949 C21.2667422,31.341013 18.6460049,32 16,32 C7.17745984,32 -5.33184608e-14,24.8225402 -5.33184608e-14,16 C-5.33184608e-14,7.17745984 7.17745984,-5.33184608e-14 16,-5.33184608e-14 Z M22.3469041,9.78532373 C22.7170021,9.35354267 23.3670536,9.30353871 23.7988347,9.67363677 C24.1361233,9.96274131 24.244286,10.4284868 24.083493,10.8365215 L24.0105106,10.9863716 L23.9105216,11.1255674 L14.4055712,22.2146763 C14.1009921,22.5700185 13.6036048,22.6687212 13.1863061,22.4747317 L13.0341063,22.3881953 L12.8956524,22.2726644 L8.14317718,17.5201892 C7.74105315,17.1180651 7.74105315,16.4660933 8.14317718,16.0639693 C8.45729902,15.7498474 8.92996834,15.6777244 9.32446889,15.8693385 L9.4682801,15.953599 L9.59941483,16.063987 L13.5635644,20.030099 L22.3469041,9.78532373 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Test-320",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calculadora-cantidad-05",
    transform: "translate(-15.000000, -202.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(0.000000, -8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(0.000000, 195.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(15.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Icon",
    fill: "#008A00",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSuccess);
export default __webpack_public_path__ + "static/media/ico-success.00fe366b.svg";
export { ForwardRef as ReactComponent };